import { ApplyCTA } from "./ApplyCTA";
import { useT } from "../../i18n";

export const FinalCTA = () => {
  const t = useT();
  return (
    <>
      <hr className="sp-gold-rule" />
      <section className="sp-cta" data-testid="section-final-cta">
        <div className="sp-container sp-reveal">
          <h2>
            {t.finalCTA.titleLine1}
            <br />
            {t.finalCTA.titleLine2Pre}
            <em>{t.finalCTA.titleLine2Em}</em>
          </h2>
          <p>{t.finalCTA.body}</p>
          <ApplyCTA testId="final-cta-apply" variant="primary">
            {t.finalCTA.cta}
          </ApplyCTA>
          <p className="sp-cta-disclaimer">{t.finalCTA.disclaimer}</p>
        </div>
      </section>
    </>
  );
};

export const TeamTraining = () => {
  const t = useT();
  return (
    <section className="sp-team" data-testid="section-team">
      <div className="sp-container">
        <div className="sp-team-row sp-reveal">
          <div>
            <span className="sp-eyebrow">{t.team.eyebrow}</span>
            <h3>{t.team.title}</h3>
            <p>{t.team.body}</p>
          </div>
          <div>
            <ApplyCTA testId="team-cta-apply" variant="primary">
              {t.team.cta}
            </ApplyCTA>
          </div>
        </div>
      </div>
    </section>
  );
};
